export default "__VITE_ASSET__DiwmFYnV__"